import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const ImporteFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-entregaARenidr-moneda', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='IMPORTE' htmlFor='input-entregaARenidr-importe' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='importe'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id='input-entregaARenidr-importe'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteFormGroup)
